import { createElement } from 'react';
import Img from '@icedesign/img';
const GeneralImg = function GeneralImg({ src = '', style = {}, ...otherProps }) {
    const _otherProps = otherProps || {};
    _otherProps.src = src;
    _otherProps.style = style;
    console.log("🚀 ~ file: general-img.tsx:18 ~ _otherProps", _otherProps);
    return (createElement(Img, { ..._otherProps }));
};
export default GeneralImg;
